"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCheapestRate = void 0;
const getCheapestRate = (rates) => {
    const cheapest_rate = rates.reduce((prev, curr) => {
        return prev.sell_price < curr.sell_price ? prev : curr;
    });
    return cheapest_rate;
};
exports.getCheapestRate = getCheapestRate;
